"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _querystring = require("./utility/querystring");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const apiHost = process.env.VUE_APP_ZWAN_SPACES_API_HOST || 'https://app.spaces.zwan.it';
const apiConfig = {
  url: apiHost,
  namespace: 'api',
  version: 'v1'
};

const client = _axios.default.create({
  baseURL: apiConfig.url,
  withCredentials: true,
  // required to handle the CSRF token
  headers: {
    post: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }
});

class SSO {
  constructor() {
    _defineProperty(this, "token", null);

    _defineProperty(this, "host", `${apiConfig.namespace}/${apiConfig.version}`);

    /**
     * If Zwan Spaces token is in request, set as Bearer.
     */
    if (_querystring.token) {
      this.token = _querystring.token;
      client.interceptors.request.use(config => {
        const newConfig = config;
        newConfig.headers.Authorization = `Bearer ${_querystring.token}`;
        return newConfig;
      }, null);
    }
  }

  getUrl(endpoint) {
    const {
      host
    } = this;
    return `${host}/${endpoint}/`;
  }
  /**
   * Get current user data.
   */


  user(params = {}) {
    if (!this.token) {
      return Promise.reject(new Error('No token.'));
    }

    const url = this.getUrl('user');
    return client.get(url, {
      params
    });
  }

}

var _default = SSO;
exports.default = _default;